import React, { useEffect, useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import api from '../../utils/functions/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

async function subscribeToPush() {
  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get(`${process.env.REACT_APP_API_URL}/push/vapid-public-key`);
  const applicationServerKey = urlBase64ToUint8Array(data.publicKey);
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });
  const json = subscription.toJSON();
  await api.post(`${process.env.REACT_APP_API_URL}/push/subscribe`, {
    endpoint: json.endpoint,
    keys: json.keys,
    userAgent: navigator.userAgent,
  });
}

export default function PushNotificationSetup() {
  const [showOptIn, setShowOptIn] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    navigator.serviceWorker
      .register('/service-worker.js')
      .then(async (registration) => {
        if (Notification.permission === 'granted') {
          const existing = await registration.pushManager.getSubscription();
          if (existing) {
            const json = existing.toJSON();
            api.post(`${process.env.REACT_APP_API_URL}/push/subscribe`, {
              endpoint: json.endpoint,
              keys: json.keys,
              userAgent: navigator.userAgent,
            }).catch(() => {});
          } else {
            subscribeToPush().catch(() => {});
          }
        } else if (Notification.permission === 'default') {
          setShowOptIn(true);
        }
      })
      .catch(() => {});
  }, []);

  if (!showOptIn) return null;

  const handleClick = async () => {
    try {
      const permission = await Notification.requestPermission();
      setShowOptIn(false);
      if (permission === 'granted') {
        await subscribeToPush();
      }
    } catch (error) {
      setShowOptIn(false);
    }
  };

  return (
    <Tooltip title="เปิดการแจ้งเตือน" placement="bottom-end" arrow>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          position: 'fixed',
          top: 8,
          right: 44,
          zIndex: 9999,
          width: 28,
          height: 28,
          backgroundColor: 'rgba(25, 118, 210, 0.9)',
          color: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
          '&:hover': { backgroundColor: 'rgba(25, 118, 210, 1)' },
        }}
      >
        <NotificationsActiveIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
